import { Outlet, RouteObject } from "react-router-dom";
import LoggedInRoute from "ui/auth/containers/LoggedInRoute/LoggedInRoute";
import RoleRoute from "ui/user/containers/RoleRoute/RoleRoute";
import MainLayout from "../components/layout/MainLayout/MainLayout";
import { MainRoutes, RouteRoles } from "./MainRouter.types";
import { lazy, Suspense } from "react";
import { useUserRoutes } from "ui/user/router/UserRouter";
import { useProgramRoutes } from "ui/program/router/ProgramRouter";
import { usePartnerRoutes } from "ui/partner/router/PartnerRouter";
import MainStatsPage from "ui/stats/pages/MainStatsPage";
import ProgramPage from "ui/program/pages/ProgramPage";
import PartnerPage from "ui/partner/pages/PartnerPage";
import PartnerPointOfSellPage from "ui/partner/pages/PartnerPointOfSellPage";
import OrchestratorPage from "ui/orchestrator/pages/OrchestratorPage";
import AdminsPage from "ui/admins/page/AdminsPage";
import GiftCardsPage from "ui/giftcards/page/GiftCardsPage";

const TransactionsPage = lazy(() => import("ui/transaction/pages/TransactionsPage"));

export const useMainRoutes = (): RouteObject[] => {
    const userRoutes = useUserRoutes();
    const programRoutes = useProgramRoutes();
    const partnerRoutes = usePartnerRoutes();

    return [
        {
            path: MainRoutes.MAIN,
            element: (
                <LoggedInRoute>
                    <MainLayout>
                        <Suspense>
                            <Outlet />
                        </Suspense>
                    </MainLayout>
                </LoggedInRoute>
            ),
            children: [
                {
                    path: MainRoutes.MAIN,
                    element: (
                        <RoleRoute roles={RouteRoles.MAIN}>
                            <MainStatsPage />
                        </RoleRoute>
                    ),
                },
                {
                    path: MainRoutes.TRANSACTIONS,
                    element: (
                        <RoleRoute roles={RouteRoles.TRANSACTIONS}>
                            <TransactionsPage />
                        </RoleRoute>
                    ),
                },
                {
                    path: MainRoutes.MY_PROGRAM,
                    element: (
                        <RoleRoute roles={RouteRoles["MY-PROGRAM"]}>
                            <ProgramPage />
                        </RoleRoute>
                    ),
                },
                {
                    path: MainRoutes.MY_PARTNER,
                    element: (
                        <RoleRoute roles={RouteRoles["MY-PARTNER"]}>
                            <PartnerPage />
                        </RoleRoute>
                    ),
                },
                {
                    path: MainRoutes.POINTS_OF_SELL,
                    element: (
                        <RoleRoute roles={RouteRoles["POINTS-OF-SELL"]}>
                            <PartnerPointOfSellPage />
                        </RoleRoute>
                    ),
                },
                {
                    path: MainRoutes.ORCHESTRATOR,
                    element: (
                        <RoleRoute roles={RouteRoles["ORCHESTRATOR"]}>
                            <OrchestratorPage />
                        </RoleRoute>
                    ),
                },
                {
                    path: MainRoutes.ADMINS_AND_SECURITY,
                    element: (
                        <RoleRoute roles={RouteRoles["ADMINS-AND-SECURITY"]}>
                            <AdminsPage />
                        </RoleRoute>
                    ),
                },
                {
                    path: MainRoutes.GIFTCARDS,
                    element: (
                        <RoleRoute roles={RouteRoles["GIFTCARDS"]}>
                            <GiftCardsPage />
                        </RoleRoute>
                    ),
                },
                ...userRoutes,
                ...programRoutes,
                ...partnerRoutes,
            ],
        },
    ];
};
